import { render, staticRenderFns } from "./OverlaySpinner.vue?vue&type=template&id=021f4899&"
import script from "./OverlaySpinner.vue?vue&type=script&lang=js&"
export * from "./OverlaySpinner.vue?vue&type=script&lang=js&"
import style0 from "./OverlaySpinner.vue?vue&type=style&index=0&id=021f4899&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports